import axios from 'axios'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { CodificationBatchUpdateRequest, CodificationRequest, CodificationResponse } from '@/modules/configurationModule/detail/local-samples/preformatted/services/preformatted.dto'

class PreformattedCodificationConfigurationServices {
    async getCodifications(laboratoryId: number, preformattedId: number): Promise<CodificationResponse> {
        const response = await axios.get<CodificationResponse>(`/configuration/laboratories/${laboratoryId}/preformatted/${preformattedId}/codifications`)
        return response.data
    }

    async createBatchCodifications(laboratoryId: number, preformattedId: number, request: CodificationRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.post<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/preformatted/${preformattedId}/codifications/createBatch`, request)
        return response.data
    }

    async deleteBatchCodifications(laboratoryId: number, preformattedId: number, codificationIds: CodificationResponse[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const params: EntityIdentifiersRequest = {
            entityIdentifiers: codificationIds.map((codification: CodificationResponse) => codification.id)
        }
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/preformatted/${preformattedId}/codifications/deleteBatch`, { data: params })
        return response.data
    }

    async updateBatchCodifications(laboratoryId: number, preformattedId: number, requests: CodificationBatchUpdateRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.put<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/preformatted/${preformattedId}/codifications/updateBatch`, requests)
        return response.data
    }
}

export const preformattedCodificationConfigurationServices = new PreformattedCodificationConfigurationServices()
